// 가로형, 검색결과, 라이크목록의 사람아이템
import {useState} from 'react';

import { ajaxor4 } from '../../common/basic';

export default props=>{
    if(!props.me) return <></>;

    // 로긴자가 이사람을 팔로잉 하고 있는가.
    // 주의. 서버api에서는 변수명을 followed라고 주고 있다. 
    // 즉, 이사람은 나로부터 following되고(followed) 있느냐 여부이다..
    const [isLoginerFollowing, setLoginerFollowing] = useState(props.me.followed);

    function toggleFollowThis() {
        ajaxor4({
            url: "/follow/user/" + props.me.id,
            callback: updateState,
        });

        function updateState(d) {
            // or unfollowed
            setLoginerFollowing((d.status == 'followed'));
        }
    }

    return (<div className="">
        <style jsx>{`

.item{
    height: 54px;
    font-size: 14px;
    color: #343a40;

    padding: 12px 16px;
}

.item.highlight{
    background-color: #55d5ce;
    opacity: 0.1;
}

.dib{
    margin: 0 10px;
}

.dib.psa{
    margin: 0;
}

div.line{
    height: initial;
    line-height: initial;
}

.nickname{
    height: 38px;
    line-height: 38px;
    vertical-align:top;
}

div.right{
    float:right;
    padding-top: 5px;
}

`}</style>

        <div className="item onhover">
            <a href={"/person/Blog?userid=" + (props.me.id)}>
                <div className="dib psa round-psa">
                    {/* <img src="/assets/images/ico-empty.svg" /> */}
                    <img src={props.me && props.me.profile_picture[0] ? props.me.profile_picture[0].optimized_url : "/assets/images/ico-empty.svg"} />
                </div>
                <div className="dib nickname">{!props.me ? '' : props.me.username}</div>
            </a>
            <div className={"right "}
                style={{display: ""+((JSON.parse("" + localStorage["loginer"]).id == props.me.id)?"none":"block")}}
             >
                <a onClick={toggleFollowThis}>
                    <img src={
                        "/assets/images/add-user" +
                        // (!props.me ? '' :props.me.followed ? "" : "_2")
                        (isLoginerFollowing ? "" : "_2")
                        + ".svg"
                    } />
                </a>
            </div>
        </div>


    </div>);
};

